/* Emerald — Ignite Pre-Order layer — DISABLED 24 Jul 2026.
 * Ignite is IN STOCK at £34.99 (variant reverted); the pre-order display reskin
 * has been removed so the buy box shows the true in-stock price and ADD TO CART.
 * The only behaviour kept is loading the Supergreens UGC reel, which this file
 * historically carried as a side effect. */
(function () {
  if (window.__emPreorder) return; window.__emPreorder = true;
  var path = location.pathname;
  var onSG = path.indexOf('/products/emerald-nutrition-supergreens') !== -1;
  if (onSG && !window.__emUGCload) {
    window.__emUGCload = 1;
    var _r = document.querySelector('script[src*="emerald-cro.js"]')
          || document.querySelector('script[src*="emerald-preorder.js"]')
          || document.querySelector('script[src*="emerald-waitlist.js"]');
    if (_r) { var _u = document.createElement('script'); _u.src = _r.src.split('?')[0].replace(/emerald-[a-z]+\.js$/, 'emerald-ugc.js') + '?v=' + Date.now(); _u.defer = true; document.head.appendChild(_u); }
  }
})();
